// Import Material UI
import { CircularProgress, DialogContent, DialogTitle, Tooltip } from '@material-ui/core';
import { Close } from '@material-ui/icons';

// Import Icons
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import automEndIcon from '../../../../assets/icons/configurationIcons/autom-end-log-icon.svg';
import LogWebhookIcon from '../../../../assets/icons/configurationIcons/Log-webhook-icon.svg';
import LogWarningIcon from '../../../../assets/icons/configurationIcons/Log-warning-icon.svg';

// Import Helper
import { convertTimestampToDate, convertToDateFormat, formatNanosecondsDifference, showPreviewData } from '../../../../helpers/helper';

// Import Packages
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { chromeDark, ObjectInspector } from 'react-inspector';

// Import Services
import LogService from '../../../../services/LogService/LogService';

// Import Recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { alertState, baseOrigin, personalizationState } from '../../../../recoil-store/recoil-state';

const defaultLibraryImg = `default_library.png`

const LogInfoDetails = ({ data, selectedLog, setSelectedLog, findLogIcon, setFullScreenValue, setOpenEhLogs, setType, label, type }) => {
    const { t } = useTranslation();
    const base_origin = useRecoilValue(baseOrigin);
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState("");
    const [output, setOutput] = useState("");
    const setAlert = useSetRecoilState(alertState);
    const personalization = useRecoilValue(personalizationState);

    useEffect((() => {
        fetchData()
    }), [selectedLog])

    const fetchData = async () => {
        try {
            let group_id = selectedLog?.group_id ? selectedLog.group_id : selectedLog?.parent_id
            if (group_id && data) {
                setLoading(true)
                const res = await LogService.getLogEntriesByGroupId(data.operation_id, group_id)
                setLoading(false)
                if (res.data) {
                    setInput(res.data.input)
                    setOutput(res.data.output)
                }
                if (selectedLog.level === "TRIGGER-PARAM") {

                    if (selectedLog.info) {
                        const params = JSON.parse(selectedLog.info)
                        if (params && !params.body) {
                            setInput(selectedLog.info)
                        }
                        else if (params && params.body) {
                            setInput(params.body)
                        }
                        if (params && params.header) {
                            setOutput(params.header)
                        }
                    }
                }
            }
        }
        catch (error) {
            console.log("error: ", error)
        }
    }

    const handleCopyInputAndOutput = async (e, text) => {
        try {
            await navigator.clipboard.writeText(text);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + `COPIED`),
                severity: 'success'
            }));
            e.preventDefault()
            e.stopPropagation()
        } catch (err) {
        }
    };


    const customTheme = {
        ...chromeDark, // chromeDark temasını baz al
        BASE_BACKGROUND_COLOR: 'transparent', // Arka plan rengini değiştir
        BASE_COLOR: 'black', // Metin rengini değiştir
        TREENODE_FONT_SIZE: '12px',
        TREENODE_LINE_HEIGHT: '1.5',
        ARROW_COLOR: "#5F5F5F"
    };

    return (<>
        <div className="all-logs-details-side-container">
            <DialogTitle DialogTitle id="alert-dialog-title" >
                <div id="about-title" className="add-group-header all-logs-header">
                    <div className="all-logs-details-header-left-side-container">
                        <div className="all-logs-details-header-title-container">
                            <img className="all-logs-details-header-action-image" src={
                                (!selectedLog.image && selectedLog.level === "TRIGGER-PARAM")
                                    ? LogWebhookIcon
                                    : (!selectedLog.image && selectedLog.level === "WARNING")
                                        ? LogWarningIcon
                                        : selectedLog.image?.includes('data:') ? selectedLog.image :
                                            `${base_origin}/libraries/${!selectedLog.image || selectedLog.is_system ? "system" : "custom"}/${selectedLog.image ? selectedLog.image : defaultLibraryImg}`
                            } />
                            {selectedLog.action_name ? <h4 className="all-logs-details-side-action-name-container">
                                <span>
                                    {selectedLog.library_label.includes('CUSTOM') ? selectedLog.library_name :
                                        t("CONTENT.LIBRARY." + selectedLog.library_name + ".NAME")}
                                    {/* {t("CONTENT.LIBRARY." + selectedLog.library_name + ".NAME")} */}
                                </span>
                                <span className='action-library-name-seperator'> - </span>
                                {selectedLog.label
                                    ? <span>{selectedLog.label}</span>
                                    : <span>
                                        {selectedLog?.library_label?.includes('CUSTOM') ? selectedLog?.action_name :
                                            t(`CONTENT.LIBRARY.${selectedLog.library_name}.ACTION.${selectedLog.action_name}`)}
                                        {/* {t(`CONTENT.LIBRARY.${log.library_name}.ACTION.${log.action_name}`)} */}
                                    </span>}
                            </h4> : "-"}
                        </div>
                        <div className="all-logs-time-elapsed-container">
                            <span className="all-logs-time-elapsed">{t(label + 'TIME-ELAPSED')}</span>
                            {selectedLog.completed_at
                                ? <span className={`log-${selectedLog.level?.toLowerCase()}`}>{formatNanosecondsDifference(selectedLog.created_at, selectedLog.completed_at)}</span> : "-"}
                        </div>
                    </div>
                    <div className="all-logs-header-right-side-container">
                        <div className={`all-logs-header-right-info all-log-${selectedLog.level?.toLowerCase()}`}>{t(label + `${selectedLog.level}`).toUpperCase()}</div>
                        <Close className="autom-group-close-button logs-close-icon" onClick={() => setSelectedLog({})} style={{ fontSize: "1rem" }} />
                    </div>
                </div>
            </DialogTitle >
            <DialogContent className="all-logs-details-main-info-container">
                <div className="all-log-details-timestamps">
                    <div className="all-log-details-timestamps-start">
                        <div className="all-logs-details-preview-buttons-container">
                            <PlayCircleFilledWhiteIcon color='red' className='log-action-image' />
                            <span className="info-body-row-value">{t(label + `STARTED-AT`)}</span>
                        </div>
                        <span className="time-of-log">{convertToDateFormat(convertTimestampToDate(selectedLog.created_at), personalization.date_format)}</span>
                    </div>
                    <div className="all-log-details-timestamps-end">
                        <div className="all-logs-details-preview-buttons-container">
                            <img src={automEndIcon} className='log-action-image' />
                            <span className="info-body-row-value">{t(label + `ENDED-AT`)}</span>
                        </div>
                        <span className="time-of-log">{selectedLog.completed_at ? convertToDateFormat(convertTimestampToDate(selectedLog.completed_at), personalization.date_format) : "-"}</span>
                    </div>
                </div>

                <div className="all-log-details-text-container">
                    <div className="log-error-header">
                        <div className='all-logs-details-text-header-row'>
                            <div className="all-logs-details-preview-buttons-container">
                                <img src={findLogIcon(selectedLog.level)} className='log-action-image' />
                                <span className={`info-body-row-value all-log-${selectedLog.level?.toLowerCase()}`}>{t(label + `${selectedLog.level}`)}</span>
                            </div>
                            {selectedLog.error || (selectedLog.info && selectedLog.level !== "TRIGGER-PARAM") ? <div className="all-logs-details-preview-buttons-container">
                                <Tooltip title={t(label + `COPY`)} placement="top" >
                                    <FileCopyIcon className='log-json-copy-icon' onClick={(e) => handleCopyInputAndOutput(e, selectedLog.error ? selectedLog.error : selectedLog.level === "TRIGGER-PARAM" ? "" : selectedLog.info)} />
                                </Tooltip>
                                <Tooltip title={t(label + `FULLSCREEN`)} placement="top" >
                                    <FullscreenIcon className="all-logs-details-preview-fullscreen-button" onClick={(e) => {
                                        setFullScreenValue({ type: "string", value: selectedLog.error ? selectedLog.error : selectedLog.level === "TRIGGER-PARAM" ? "" : selectedLog.info, cantParse: true })
                                    }} />
                                </Tooltip>
                            </div> : ""}
                        </div>
                        {selectedLog.error || (selectedLog.info && selectedLog.level !== "TRIGGER-PARAM") ? <div className="all-logs-details-side-log-text-container">
                            <p className="all-logs-details-side-log-text">{selectedLog.error ? selectedLog.error : selectedLog.level === "TRIGGER-PARAM" ? "" : selectedLog.info}</p>
                        </div> : ""}
                        {/* <span className="time-of-log">25 Feb, 2023 ; 9:10:22PM</span> */}
                    </div>
                    <div className="log-error-message">
                        <p>
                            {selectedLog.text ? selectedLog.text : ""}
                        </p>
                    </div>
                </div>

                {selectedLog.error_handling_executed ? <div className="all-logs-error-handling-button" onClick={() => setOpenEhLogs(selectedLog.group_id)}>
                    <div className={`error-handling-icon`}>
                    </div>
                    <span>{t(label + `VIEW-ERROR-HANDLING-LOGS`)}</span>
                </div> : ""}
                <div className="all-logs-input-output-container">
                    <div className="mail-server-text">
                        <div className="all-log-button-group" style={{ width: selectedLog.level === "TRIGGER-PARAM" ? "208px" : "130px" }}>
                            <div
                                onClick={() => setType("input")}
                                className={
                                    `${type === "input"
                                        ? "mail-server-button-active"
                                        : "mail-server-button"
                                    } user-select-none`}
                                style={{ width: selectedLog.level === "TRIGGER-PARAM" ? "100px" : "65px" }}
                            >
                                {t(label + (selectedLog.level === "TRIGGER-PARAM" ? "TRIGGER-BODY" : 'INPUT'))}
                            </div>
                            <div
                                onClick={() => {
                                    if (!output) return
                                    setType("output")
                                }}
                                className={
                                    `${type === "output"
                                        ? "mail-server-button-active"
                                        : "mail-server-button"} user-select-none`
                                }
                                style={{ opacity: output ? "1" : "0.5", cursor: output ? "pointer" : "default", width: selectedLog.level === "TRIGGER-PARAM" ? "100px" : "65px" }}
                            >
                                {t(label + (selectedLog.level === "TRIGGER-PARAM" ? "TRIGGER-HEADER" : 'OUTPUT'))}
                            </div>
                        </div>
                    </div>
                </div>
                {(type === "output" && output)
                    ? <div className="all-logs-details-preview-input-output-type-container">
                        <div className='preview-text'> {t(label + `ACTION-${selectedLog.level === "TRIGGER-PARAM" ? "TRIGGER" : "OUTPUT"}-TYPE`)}</div>
                        <div className="all-logs-input-output-area">
                            <p>{type === "input" ? t(label + 'OBJECT')
                                : selectedLog.level === "TRIGGER-PARAM"
                                    ? t(label + 'OBJECT')
                                    : output
                                        ? JSON.parse(output) ? JSON.parse(output).type : ""
                                        : ""}</p>
                        </div>
                    </div> : ""}
                <div className="all-logs-details-preview-container">
                    <div className='preview-text'> {t(label + "PREVIEW")}</div>
                    <div className={`${loading ? "loading-preview-data-content" : "preview-data-content"} full-height`}>
                        {loading ? <CircularProgress />
                            : <>
                                {type === "input" ? showPreviewData(input, "object")
                                    : output ? showPreviewData(output, selectedLog.level === "TRIGGER-PARAM" ? "object" : null) : ""}
                                {(type === "input" && input) || (type === "output" && output)
                                    ? <div className="all-logs-details-preview-buttons-container">
                                        <Tooltip title={t(label + `COPY`)} placement="top" >
                                            <FileCopyIcon className='log-json-copy-icon' onClick={(e) => handleCopyInputAndOutput(e, type === "input" ? input : output)} />
                                        </Tooltip>
                                        <Tooltip title={t(label + `FULLSCREEN`)} placement="top" >
                                            <FullscreenIcon className="all-logs-details-preview-fullscreen-button" onClick={(e) => {
                                                try {
                                                    let valueType = "empty";
                                                    let value = "";
                                                    if (type === "input") {
                                                        valueType = "object";
                                                        value = input;
                                                    }
                                                    else if (output) {
                                                        const logOutput = JSON.parse(output)
                                                        if (logOutput) {
                                                            valueType = selectedLog.level === "TRIGGER-PARAM" ? "object" : logOutput.type
                                                            value = output
                                                        }
                                                        else {
                                                            value = ""
                                                        }
                                                    }
                                                    setFullScreenValue({ type: valueType, value })
                                                } catch (error) {
                                                    console.log("error: ", error)
                                                }
                                            }} />
                                        </Tooltip>
                                    </div> : ""} </>}
                    </div>
                </div>
            </DialogContent>
        </div >
    </>
    )
}

export default LogInfoDetails